import * as React from 'react'
import cx from 'classnames'
import * as styles from './circle.tabs.styl'
import { map } from 'lodash'
import CircleTab, { TabProps } from './components/item.circle.tab'

export enum StepDirection {
  forward = 'forward',
  back = 'back'
}

export interface Tabs {
  [key: number]: TabProps
}

export interface Props {
  completedSteps: number[]
  currentTab: number
  tabs: Tabs | TabProps[]
  switchStep: (step: number) => void
}
export interface State {
  stepDirection: StepDirection
}

const CircleTabs: React.FC<Props> = (props: Props) => {
  const { completedSteps, currentTab, tabs } = props
  const [state, setState] = React.useState<State>({ stepDirection: null })

  function switchStep(step: number) {
    const { switchStep } = props
    // set step direction for gear animation
    let stepDirection = StepDirection.forward
    if (currentTab > step) stepDirection = StepDirection.back
    setState({ stepDirection })

    if (typeof switchStep === 'function') {
      switchStep(step)
    }
  }

  function isCompletedTab(id: number) {
    return completedSteps[id] !== 0
  }

  function isActiveTab(id: number) {
    return currentTab === id
  }

  return (
    <div className={styles.circle}>
      <i
        className={cx('material-icons', styles[state.stepDirection])}
        onAnimationEnd={() => setState({ stepDirection: null })}
      >
        settings
      </i>
      <div>
        {map(tabs, (x, key) => (
          <CircleTab
            selectorId={x.selectorId}
            key={x.title.replace(/\s/g, '')}
            id={Number(key)}
            isCompleted={isCompletedTab(Number(key))}
            isActive={isActiveTab(Number(key))}
            title={x.title}
            className={x.className}
            onClick={switchStep}
          />
        ))}
      </div>
    </div>
  )
}

export default CircleTabs
